import { useQuery } from 'react-query';

import { getAuditedCard as queryFn } from 'api/endPoints/getAuditedCard';

import { IAssignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryActivityLog = (params: { id?: number; isVirtual?: boolean; versionId?: number }) => {
    return useQuery<IActivityLogResponse[], QueryError>(['activityLog', params], () => queryFn(params), {
        enabled: Boolean(params.versionId),
    });
};

export interface IActivityLogResponse {
    changeDate: number;
    fieldName: string;
    firstName: string;
    lastName: string;
    newValues: string;
    oldValues: string;
    revision: number;
    userName: string;
    userChanger: IAssignee;
}
